
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/items/[id]/related",
      function () {
        return require("private-next-pages/items/[id]/related.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/items/[id]/related"])
      });
    }
  